import PropTypes from 'prop-types';

export const stepShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  done: PropTypes.bool,
});

export const commentShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  user_id: PropTypes.number,
  author: PropTypes.string,
  body: PropTypes.string.isRequired,
  created_at: PropTypes.string.isRequired,
});

export const taskShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  status: PropTypes.string.isRequired,
  priority: PropTypes.string.isRequired,
  due_on: PropTypes.string,
  assignee_id: PropTypes.number,
  assignee_name: PropTypes.string,
  position: PropTypes.number,
  checklist: PropTypes.arrayOf(stepShape),
  comments: PropTypes.arrayOf(commentShape),
  created_at: PropTypes.string,
  updated_at: PropTypes.string,
  completed_at: PropTypes.string,
});

export const eventShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  on_date: PropTypes.string.isRequired,
});

export const personShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string,
});
